import { api } from '../../DefaultService';
import {
  ISevenEduCreateProps,
  ISevenEduProps,
  ISevenEduUpdateParams,
} from './types';

const ENDPOINT = '/v1/integrations/seven-edu';

export const createSevenEduIntegrationAsync = async (
  data: ISevenEduCreateProps,
) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSevenEduIntegrationsAsync = async (): Promise<
  ISevenEduProps[]
> => {
  return await api
    .get<ISevenEduProps[]>(`${ENDPOINT}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSevenEduIntegrationByIdAsync = async (
  id: number,
): Promise<ISevenEduProps> => {
  return await api
    .get<ISevenEduProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSevenEduIntegrationAsync = async ({
  id,
  data,
}: ISevenEduUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSevenEduIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
